import { RouteObject } from "react-router-dom";

export const ticketValidationRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Ticket Validation" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          // Redirect to /ticket-validation/returns for backward compatibility
          const { Navigate } = await import("react-router-dom");
          return {
            element: <Navigate replace to="/ticket-validation/returns" />,
          };
        },
      },
      {
        path: "returns",
        handle: { breadcrumb: "Returns" },
        async lazy() {
          const { TicketValidationPage } = await import(
            "./ticket-validation-page"
          );
          return { Component: TicketValidationPage };
        },
      },
    ],
  },
];
